/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _, { update } from 'lodash';
import { Link, useHistory } from 'react-router-dom';

import { Tooltip } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import PriceTypeCustomCheckbox from '../../../../System/priceType/components/PriceTypeCustomCheckbox';
import CustomDateComponent from '../../../NDC/component/CustomDateComponent';
import { selectClaimTableHead } from '../../utils/tablehead';
import CustomClaimOriginalUnit from './CustomClaimOriginalUnit';
import CustomPriceComponent from './CustomPriceComponent';
import CustomSelectedClaimAction from './CustomSelectedClaimAction';
import CustomSelectedClaimTextField from './CustomSelectedClaimTextField';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  navigateToProvider,
  setCellFocused,
  setEditedRows,
} from '../../store/action';
import {
  handleOnKeyDownEventWithSelectValue,
  redirectURLLink,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getProviderIdTypeDetails } from '../../../Provider/store/action';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { getClaimDetails } from '../../../ClaimDetails/store/actions';

const SelectedClaimsTable = ({
  tableData = [],
  claimReferenceData,
  systemParameter,
  claimSelectByFilter,
  tableFullScreen,
  setTableFullScreen,
  setStateChange,
  hasAccess,
  setSuccessMessages
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedClaimRecordIndex = useSelector(
    (state) => state.sharedState.claim.selectedClaimRecordIndex
  );
   const selectedClaimMode = useSelector(state=>state.sharedState?.claim.selectedClaimMode)
    const is508NotReq = useSelector(
      (state) => state?.sharedState.UserDefaultReducer.override508Compliance
    );
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CheckLogReducer.generalSystemParameter
      ?.paramGeneralVO;
  });
  // const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const { editedData, cellFocused } = useSelector(
    (state) => state.sharedState.claim
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const reduxSelectedClaim = useSelector(
    (state) => state?.sharedState?.claim?.selectedClaim
  );
  const gridRef = React.useRef();
  const [gridApi, setGridApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [columnApi, setColumnApi] = useState(null);
  const [updatedTable, setUpdatedTable] = useState(tableData);
  const [columnDefs, setColumnDefs] = React.useState(selectClaimTableHead);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  // handle system parameters
  React.useEffect(() => {
    let tableHead = [];
    tableHead =
      columnDefs &&
      columnDefs.filter((x) => {
        if (
          claimSelectByFilter?.rebateProgramCd !== 'ALL' &&
          generalSystemParameterDetails?.length > 0 &&
          parseInt(
            generalSystemParameterDetails[0]?.drugGrossAmtInd,
            [0, 1]
          ) === 0
        ) {
          return x.field !== 'rebateProgramCd' && x.field !== 'drugGrossAmt';
        }
        if (
          claimSelectByFilter?.rebateProgramCd !== 'ALL' &&
          generalSystemParameterDetails?.length > 0 &&
          parseInt(
            generalSystemParameterDetails[0]?.drugGrossAmtInd,
            [0, 1]
          ) === 1
        ) {
          return x.field !== 'rebateProgramCd';
        }
        if (
          claimSelectByFilter?.rebateProgramCd === 'ALL' &&
          generalSystemParameterDetails?.length > 0 &&
          parseInt(
            generalSystemParameterDetails[0]?.drugGrossAmtInd,
            [0, 1]
          ) === 0
        ) {
          return x.field !== 'drugGrossAmt';
        }
        return x;
      });
    setColumnDefs(tableHead);
  }, [generalSystemParameterDetails]);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  const bringFocusBack = () => {
    if (gridApi) {
      const cell = gridApi.getFocusedCell();
      if (cell && cellFocused === -1) {
        dispatch(setCellFocused(cell.rowIndex));
        gridApi.setFocusedCell(cell.rowIndex, cell.column);
      }
    }
  };

  React.useEffect(() => {
    // setTableCount(gridApi && gridApi.getDisplayedRowCount());
    if (gridApi) {
      const cell = gridApi.getFocusedCell();
      if (cell) {
        gridApi.ensureIndexVisible(cell.rowIndex, undefined);
      }
    }
  }, [gridApi, updatedTable]);

  useEffect(() => {
    if (tableData?.length > 0) {
      const newTableData = tableData.map((row) => {
        const editedRow = editedData?.find(
          (item) =>
        item.claimIdVO?.claimId === row.claimIdVO?.claimId &&
        item.claimIdVO?.claimLineNum === row.claimIdVO?.claimLineNum
        );
        if (editedRow) {
          editedRow.finalBilledUnits = editedRow?.billedUnits
            ? editedRow.billedUnits
            : editedRow.origNumOfUnits;
          return editedRow;
        }
        row.finalBilledUnits = row?.billedUnits
          ? row.billedUnits
          : row.origNumOfUnits;
        return row;
      });
      setUpdatedTable(newTableData);
      if (editedData && editedData.length > 0) bringFocusBack();
    } else {
      setUpdatedTable([]);
    }
  }, [tableData, editedData]);

  const calculateTotalSum = (property) => {
    let data = 0;
    if (property === 'invoicedInd') {
      data = updatedTable.length;
    } 
    // else if (property === 'billedUnits') {
    //   data = updatedTable?.reduce((accumulator, object) => {
    //     return (
    //       accumulator +
    //       (object[property]
    //         ? parseFloat(object[property])
    //         : object.origNumOfUnits
    //         ? parseFloat(object.origNumOfUnits)
    //         : 0)
    //     );
    //   }, 0);
    // } 
    else {
      data = updatedTable?.reduce((accumulator, object) => {
        return (
          accumulator + (object[property] ? parseFloat(object[property]) : 0)
        );
      }, 0);
    }

    return data ? parseFloat(data) : 0;
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        invoicedInd: calculateTotalSum('invoicedInd'),
        origNumOfUnits:
          calculateTotalSum('origNumOfUnits') === 0
            ? '0.0000'
            : calculateTotalSum('origNumOfUnits')?.toFixed(4),
        numOfUnits:
          calculateTotalSum('numOfUnits') === 0
            ? '0.0000'
            : calculateTotalSum('numOfUnits')?.toFixed(4),
        billedUnits:
          calculateTotalSum('billedUnits') === 0
            ? '0.0000'
            : calculateTotalSum('billedUnits')?.toFixed(4),
        hcpcsUnits:
          calculateTotalSum('hcpcsUnits') === 0
            ? '0.0000'
            : calculateTotalSum('hcpcsUnits')?.toFixed(4),
        reimbursementAmt: calculateTotalSum('reimbursementAmt'),
        tplAmt: calculateTotalSum('tplAmt'),
        copayAmt: calculateTotalSum('copayAmt'),
        deductibleAmt: calculateTotalSum('deductibleAmt'),
        drugGrossAmt: '',
        ccCommentsExist: 'Total',
        isBottomRow: true,
      });
    }
    if (prefix === 'Bottom') {
      // For the bottom pinned row, set editable to false
      result.forEach((row) => {
        row.editable = false;
      });
    }
    return result;
  };

  const pinnedBottomRowData = React.useMemo(() => {
    return createData(1, 'Bottom');
  }, [updatedTable]);

  const getReferenceValue = (data, value) => {
    if (value && data && data.length > 0) {
      const index = data.findIndex(
        (item) => item?.codeValueID?.codeValue === value
      );
      if (index !== -1) {
        return data[index].shortDescription;
      }
      return '';
    }
    return null;
  };
  const handleViewHistory = (gridApi) => {
    setSuccessMessages([])
    const selectedRow = gridApi.getSelectedRows()?.[0]?.claimIdVO;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CLAIM_ID: `${selectedRow?.claimId}`,
        CLAIM_LINE_NUM: `${selectedRow?.claimLineNum}`,
      });
    }
  };

  const handleFullScreenViewClick = () => {
    setSuccessMessages([])
    setTableFullScreen(!tableFullScreen);
  };

  const setEditedData = (value) => dispatch(setEditedRows(value));

  // get edited data
 const onEditingStopped = (e) => {
  if (e && e.value !== e.oldValue) {
    const obj = e.data;

    // Remove the object if already in editedData (by reference), then push updated version
    const newData = editedData?.filter((item) => item !== obj) || [];
    newData.push(obj);
    setEditedData(newData);
  }
};
  // Go to Claims redirection API call
  const handleViewDetailsForClaims = (data) => {
    setSuccessMessages([])
    dispatch(
      getClaimDetails({
        claimId: data?.claimId,
        claimLineNum: data?.claimLineNum,
        eventInquryKeyVO: [
          {
            keyType: 'Claim ID',
            key: `${data?.claimId}-${data?.claimLineNum}`,
          },
        ],
        functionCode: 'Claim',
        userID: logInUser,
      })
    );
    redirectURLLink(
      `/claimDetails/${data.claimId}`,
      `Claim Details [${data.claimId}]`,
      history,
      dispatch
    );
  };
  // Go to Provider Redirection API call
  const goToProvider = (cellInfo) => {
    const payload = {
      providerId: cellInfo.providerId,
      providerIdTypeCd: cellInfo.providerIdTypeCd,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payload, () => {
        redirectURLLink(
          '/ProviderDetails',
          'Provider Details',
          history,
          dispatch
        );
      })
    );
  };
  const frameworkComponents = React.useMemo(() => {
    return {
      CustomCheckboxRenderer: (cellInfo) => {
        if (cellInfo?.data?.isBottomRow) {
          return (
            <div className="semiBoldText">{cellInfo?.data?.invoicedInd}</div>
          );
        }
        if (cellInfo.column.colId?.trim() === 'reversingClaimLineNum') {
          return (
            <PriceTypeCustomCheckbox
              {...cellInfo}
              value={cellInfo?.data?.reversingClaimLineNum}
              disabled
              tabIndex={-1}
            />
          );
        }
        return (
          <div
            className="tbl-checkbox"
            id="checkbox"
            style={{ textAlign: 'left', float: 'left' }}
          >
            <FormControlLabel
              id={`NumberOfUnit${cellInfo?.rowIndex}`}
              control={<Checkbox color="primary" tabIndex={-1} />}
              disabled
              checked={cellInfo?.data[cellInfo.column.colId?.trim()] === 1}
              value={cellInfo?.data[cellInfo.column.colId?.trim()] === 1}
              aria-label="checkbox"
            />
          </div>
        );
      },
      DateCellRenderer: CustomDateComponent,
      TextFieldComponentRenderer: (props) => (
        <CustomSelectedClaimTextField
          {...props}
          setStateChange={setStateChange}
          systemParameter={systemParameter}
          // isEnablebyRole={isEnablebyRole}ss
        />
      ),
      NoDataComponentRenderer: () => <></>,
      totalText: () => <span className="semiBoldText">Total</span>,
      ClaimOriginalUnitsRenderer: CustomClaimOriginalUnit,
      PriceComponentCellRenderer: CustomPriceComponent,
      ActionCellRender: (params) => {
        if (params.data?.isBottomRow) {
          return <span className="semiBoldText">Total</span>;
        }
        return <CustomSelectedClaimAction hasAccess={hasAccess} {...params} />;
      },
      CategoryCompCellRenderer: (cellInfo) => {
        const name = cellInfo?.data?.computedCategoryCd;
        if (cellInfo?.data?.isBottomRow) {
          return '';
        }
        if (name && name.length > 16) {
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
            >
              <div>{name && `${name?.substring(0, 16)}...`}</div>
            </OverlayTrigger>
          );
        }
        return <div>{name}</div>;
      },
      ProviderIdCellRender: (cellInfo) => {
        const handleProviderLinkKeyDown = (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            goToProvider(cellInfo.data);
          }
        };
        return (
          <Link
            to="#"
            role="button"
            onClick={() => {
              goToProvider(cellInfo.data);
            }}
            onKeyDown={handleProviderLinkKeyDown}
          >
            {cellInfo && cellInfo.data?.providerId}
          </Link>
        );
      },
      ClaimIdCellRender: (cellInfo) => {
        const handleClaimLinkKeyDown = (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            handleViewDetailsForClaims(cellInfo.data?.claimIdVO);
          }
        };
        return (
          <Link
            to="#"
            role="button"
            onClick={() => {
              handleViewDetailsForClaims(cellInfo.data?.claimIdVO);
            }}
            onKeyDown={handleClaimLinkKeyDown}
          >
            {cellInfo && cellInfo.data?.claimIdVO?.claimId}
          </Link>
        );
      },
    };
  }, [hasAccess]);
  const onCellKeyDown = React.useCallback((e) => {
    setSuccessMessages([])
    const keyboardEvent = e?.event;
    const { key } = keyboardEvent;
    if (key?.length && (key === 'Enter' || key === ' ')) {
      if (gridRef?.current?.api) {
        gridRef.current.api.forEachNode((node) => {
          if (node.rowIndex === e.rowIndex) {
            node.setSelected(true);
          }
        });
      }
    }

    //page key fix
    if (key === 'PageDown') {
      const api = gridRef?.current?.api || e.api;
      if (!api) return;
      
  const { top, bottom } = api.getVerticalPixelRange(); 
  const model = api.getModel(); 
  const first = model.getRowIndexAtPixel(top);
  const last  = model.getRowIndexAtPixel(bottom);

  const visible = [];
  api.forEachNodeAfterFilterAndSort((node, displayIndex) => {
    if (displayIndex >= first && displayIndex <= last) visible.push(node);
  });
      try {
        api.deselectAll();

        
        api.setFocusedCell(visible?.[1]?.rowIndex, e.column);
        api.ensureIndexVisible(visible?.[1]?.rowIndex, 'top');
      } catch (err) {
      }
    }
    if ( key === 'PageUp') {
          const api = gridRef?.current?.api || e.api;
      if (!api) return;
     const { top, bottom } = api.getVerticalPixelRange(); 
  const model = api.getModel(); 
  const first = model.getRowIndexAtPixel(top);
  const last  = model.getRowIndexAtPixel(bottom);

  const visible = [];
  api.forEachNodeAfterFilterAndSort((node, displayIndex) => {
    if (displayIndex >= first && displayIndex <= last) visible.push(node);
  });
    try {
        api.deselectAll();

        
        api.setFocusedCell(visible?.[0]?.rowIndex, e.column);
        api.ensureIndexVisible(visible?.[0]?.rowIndex, 'top');
      } catch (err) {
      }
    }
    //arroe key fix
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      try {
        keyboardEvent.preventDefault();
        keyboardEvent.stopPropagation();
      } catch (err) {}

      const api = gridRef?.current?.api || e.api;
      if (!api) return;

      const totalRows = api.getModel().getRowCount();
      const isDown = key === 'ArrowDown';
      const changeArrow = isDown ? 1 : -1;
      const targetIndex = Math.max(
        0,
        Math.min(totalRows - 1, (typeof e.rowIndex === 'number' ? e.rowIndex : 0) + changeArrow)
      );

      api.deselectAll();
      api.forEachNode((node) => {
        if (node.rowIndex === targetIndex) node.setSelected(true);
      });
      api.setFocusedCell(targetIndex, e.column);
      api.ensureIndexVisible(targetIndex);

      return;
    }
    if (key === 'Tab' && e?.column?.colId === 'origNumOfUnits') {
      const eventValue = {
        ...keyboardEvent,
        key: key,
      };
      handleOnKeyDownEventWithSelectValue(
        eventValue,
        `label_numOfUnits_${e?.rowIndex}`
      );
    }
  }, []);
  const tabToNextEditableCell = (params) => {
    setSuccessMessages([]);
    const { previousCellPosition, backwards, api, columnApi } = params;
    const displayedColumns = columnApi.getAllDisplayedColumns();
    const totalRows = api.getModel().getRowCount();

    // Safety: ensure there is at least one editable cell
    let hasEditable = false;
    for (let r = 0; r < totalRows && !hasEditable; r += 1) {
      for (let c = 0; c < displayedColumns.length && !hasEditable; c += 1) {
        const col = displayedColumns[c];
        const isEditable =
          col?.colDef?.cellRenderer === 'TextFieldComponentRenderer';
        const allowEdit =
          selectedClaimMode !== 'display' && hasAccess === true && isEditable;
        if (allowEdit) {
          hasEditable = true;
        }
      }
    }
    if (!hasEditable) {
      return null;
    }

    let nextRowIndex = previousCellPosition.rowIndex;
    let nextColIndex = displayedColumns.findIndex(
      (col) => col === previousCellPosition.column
    );
    const step = backwards ? -1 : 1;

    while (true) {
      nextColIndex += step;

      if (nextColIndex >= displayedColumns.length) {
        nextColIndex = 0;
        nextRowIndex += 1;
      } else if (nextColIndex < 0) {
        nextColIndex = displayedColumns.length - 1;
        nextRowIndex -= 1;
      }

      // Wrap rows instead of stopping
      if (nextRowIndex >= totalRows) {
        nextRowIndex = 0;
      } else if (nextRowIndex < 0) {
        nextRowIndex = totalRows - 1;
      }

      const nextCol = displayedColumns[nextColIndex];
      const isEditable =
        nextCol?.colDef?.cellRenderer === 'TextFieldComponentRenderer';
      const allowEdit =
        selectedClaimMode !== 'display' && hasAccess === true && isEditable;

      if (allowEdit) {
        return {
          rowIndex: nextRowIndex,
          column: nextCol,
          floating: null,
        };
      }
    }
  };
 const onCellFocusedEditable = (p) => {
  setSuccessMessages([])
    if (p.rowIndex == null || p.column?.colId == null || !p.api) return;
  
    const colId = p.column.colId;
    const rowIndex = p.rowIndex;
    const editableCols = ['numOfUnits', 'billedUnits'];
    const selectedClaimMode = p.context?.selectedClaimMode;  
    const allowEdit = editableCols.includes(colId) && selectedClaimMode !== 'display' && hasAccess;
  
    if (allowEdit) {
      p.api.startEditingCell({
        rowIndex,
        colKey: colId
      });
    }
  
    // DOM focus logic after AG Grid renders the editor
    requestAnimationFrame(() => {
      const dom = p.api.gridOptionsWrapper.eGridDiv.children[0];
  
      const rowSelector =
        p.rowPinned === 'bottom'
          ? `.ag-floating-bottom-container div[row-index="b-${p.rowIndex}"]`
          : `.ag-center-cols-container div[row-index="${p.rowIndex}"]`;
  
      const row = dom?.querySelector(rowSelector);
      const col = row?.querySelector(`div[col-id="${p.column.colId}"]`);
  
      const input = col?.querySelector('input');
      const select = col?.querySelector('select');
  
      if (input && document.activeElement !== input) {
        input.focus();
        input.select();
      } else if (select && document.activeElement !== select) {
        select.focus();
      }
    },);
  };
  const toQuarterLabel=(value)=> {
  if (value == null) return null;

  const str = String(value).trim();
  if (!/^\d{5}$/.test(str)) return null;

  const year = str.slice(0, 4);
  const quarter = Number(str.slice(4));

  if (quarter < 1 || quarter > 4) return null;

  return `${quarter}Q${year}`;
}
const download = async () => {
  try {
    const api = gridRef?.current?.api;
    let source = [];
    if (api){
      api.forEachNodeAfterFilterAndSort((node)=>{
       if(node?.data && !node?.data?.isBottomRow){
        source.push(node.data)
       }
      })
    }
    if(source.length === 0){
      source = (updatedTable || []).filter((item)=>!item.isBottomRow)
    }

    // if (reduxSelectedClaim && Array.isArray(reduxSelectedClaim) && reduxSelectedClaim.length > 0) {
    //   source = reduxSelectedClaim;
    // } else if (reduxSelectedClaim && typeof reduxSelectedClaim === 'object' && Object.keys(reduxSelectedClaim).length > 0) {
    //   source = Object.values(reduxSelectedClaim).filter(Boolean);
    // } else if (api && api.getSelectedRows && api.getSelectedRows().length > 0) {
    //   source = api.getSelectedRows();
    // } else {
    //   source = updatedTable || [];
    // }

    const claimMap = new Map(); 

    const addClaim = (claimIdVO) => {
      if (!claimIdVO) return;
      const cid = claimIdVO.claimId || claimIdVO.claimID || claimIdVO.claimid;
      const cl = claimIdVO.claimLineNum || claimIdVO.claimLine || claimIdVO.lineNum || 1;
      if (!cid) return;
      const key = `${cid}-${cl}`;
      if (!claimMap.has(key)) {
        claimMap.set(key, { claimId: cid, claimLineNum: cl });
      }
    };

    source.forEach((item) => {
      if (!item) return;

      if (item.claimResultVOList && Array.isArray(item.claimResultVOList)) {
        item.claimResultVOList.forEach((cr) => {
          if (cr && cr.claimVOList && Array.isArray(cr.claimVOList)) {
            cr.claimVOList.forEach((c) => addClaim(c?.claimIdVO || c));
          } else {
            addClaim(cr?.claimIdVO || cr);
          }
        });
        return;
      }

      if (item.claimVOList && Array.isArray(item.claimVOList)) {
        item.claimVOList.forEach((c) => addClaim(c?.claimIdVO || c));
        return;
      }

      if (item.claimIdVO) addClaim(item.claimIdVO);
      else if (item.claimId) addClaim({ claimId: item.claimId, claimLineNum: item.claimLineNum || 1 });
    });

    const payload = Array.from(claimMap.values()).map((c) => ({
      claimId: c.claimId,
      claimLineNum: c.claimLineNum,
      userID: logInUser,
      functionCode: 'Claim',
      eventInquryKeyVO: [
        {
          keyType: 'claimId',
          key: `${c.claimId}-${c.claimLineNum}`,
        },
      ],
    }));

    if (payload.length === 0) {
      return { jsonData: [], boldRows: [] };
    }

    const response = await axios.post(serviceEndPoint.SEARCH_CLAIM_DATA_INFO, payload);

    const  convertTimestampToDate =(timestamp)=> {
  const date = new Date(timestamp);
  
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${month}/${day}/${year}`;
}

    const mapRowToExcel = (row) => {
      const g = (p) => {
        try {
          return p === undefined || p === null ? '' : p;
        } catch (e) {
          return '';
        }
      };

      return {
        claim_id: g(row.claimIdVO?.claimId ),
        claim_line_num: g(row.claimIdVO?.claimLineNum),
        prev_claim_id: g(row.prevClaimId ),
        reversing_claim_id: g(row.reversingClaimId ),
        provider_id_type_cd: g(row.providerIdTypeCd ),
        provider_id: g(row.providerId ),
        prescription_num: g(row.prescriptionNum ),
        service_dt: g(convertTimestampToDate(row?.serviceDt) ),
        mco_paid_dt: g(convertTimestampToDate(row?.mcoPaidDt) ),
        num_of_units: g(row?.numOfUnits ),
        database_units: g(row?.numOfUnits ??'' ),
        orig_num_of_units: g(row?.origNumOfUnits ),
        hcpcs_units: g(row?.hcpcsUnits? row?.hcpcsUnits:0),
        submitted_amt: g(row?.submittedAmt ),
        reimbursement_amt: g(row?.reimbursementAmt),
        rebate_program_cd: g(row?.rebateProgramCd ),
        drug_seq_num: g(row?.drugSeqNum ),
        corr_link_id: g(row?.corrLinkId??'' ),
        cc_reversal_ind: g(row?.reversalClaimInd??'' ),
        cc_comments_exist: g(row?.commentsCount??'' ),
        invoiced_ind: g(row?.invoicedInd),
        supp_invoiced_ind: g(row?.suppInvoicedInd??'' ),
        non_invoice_reason_cd: g(row?.nonInvoiceReasonCd ??'' ),
        supp_non_invoice_reason_cd: g(row?.suppNonInvoiceReasonCd??'' ),
        labeler_code: g(row?.labelerCode??'' ),
        client_id: g(row?.clientId ??'' ),
        group_id: g(row?.groupId ??'' ),
        plan_id: g(row?.planId??'' ),
        claim_category_cd: g(row?.claimCategoryCd||'' ),
        paid_dt: g(convertTimestampToDate(row?.paidDt)||'' ),
        drams_qtr: g(toQuarterLabel(row?.dramsQtr)||'' ),
        paid_qtr: g(toQuarterLabel(row?.paidQtr)||'' ),
        tpl_amt: g(row?.tplAmt ? row?.tplAmt : 0 ),
        copay_amt: g(row?.copayAmt ?? '' ),
        deductible_amt: g(row?.deductibleAmt ? row?.deductibleAmt : 0 ),
        adjustment_cd: g(row?.adjustmentCd??''),
        ndc: g(row?.drugVO?.ndc ?? '' ),
        allowed_amt: g(row?.allowedAmt ?row?.allowedAmt:0),
        billed_units: g(row?.billedUnits ? row?.billedUnits : 0),
        status_cd: g(row?.billedStatusCd??'' ),
        create_dt: g(convertTimestampToDate(row?.billedCreatedDt)||'' ),
        supp_invoice_num: g(row?.suppInvoiceNum||'' ),
        db_billed_units: g(row?.billedUnits ?row?.billedUnits: 0 ),
        replacing_claim_id: g(row?.replacingClaimId||'' ),
        reversing_claim_line_num: g(row?.reversingClaimLineNum||'' ),
        replacing_claim_line_num: g(row?.replacingClaimLineNum||''),
        prev_claim_line_num: g(row?.prevClaimLineNum||'' ),
        med_unit_type_cd: g(row?.medUnitTypeCd||'' ),
        wd_num_of_units: g(row?.wdNumOfUnits||'' ),
        wd_dispute_cd: g(row?.wdDisputeCd||'' ),
        wd_status_cd: g(row?.wdStatusCd||'' ),
        alt_provider_id: g(row?.altProviderId||'' ),
        alt_provider_id_type_cd: g(row?.altProviderIdTypeCd||'' ),
        drug_gross_amt: g(row?.drugGrossAmt ? row?.drugGrossAmt :0 ),
        unlmt_flg: g(row?.unlmtFlag||'' ),
        patient_id: g(row?.patientId||'' ),
        drug_cmpnd_ind: g(row?.drugCmpndInd||'' ),
        daw_ind: g(row?.dawInd??'' ),
        ltc_ind: g(row?.ltcInd||'' ),
        procedure_cd: g(row?.procedureCd||'' ),
        supplied_days: g(row?.suppliedDays??'' ),
        nabp_num: g(row?.nabpNum??'' ),
        supp_ndc_exc_ind: g(row?.suppNdcExcInd||''),
        'Provider One TCN': g('' ),
      };
    };

    if (response?.data) {
      const rows = response.data.data || response.data || [];
      const mapped = Array.isArray(rows) ? rows.map(mapRowToExcel) : [];
      return { jsonData: mapped, boldRows: [] };
    }

    return { jsonData: [], boldRows: [] };
  } catch (err) {
    return { jsonData: [], boldRows: [] };
  }
};
const suppressNavigation = ( params)=>{
  const { key } = params.event;
  return key === 'PageDown' || key === 'PageUp';

}
  return (
    <div className="table-container eightRecords col-12 no-border mt-4">
      <Grid
        ref={gridRef}
        gridCall={onGridReady}
        gridHeight={tableFullScreen ? '100vh' : 350}
        rowData={
          updatedTable?.length > 0
            ? updatedTable?.map((item) => {
                item.computedCategoryCd = getReferenceValue(
                  claimReferenceData?.CLAIM_CATEGORY_CD,
                  item?.claimCategoryCd
                );
                item.providerIdTypeVal = item?.providerIdTypeCd
                  ? getReferenceValue(
                      claimReferenceData?.PROVIDER_ID_TYPE_CD,
                      item?.providerIdTypeCd
                    )
                  : null;
                item.drugGrossAmt = parseFloat(item.drugGrossAmt || 0)?.toFixed(
                  2
                );
                item.ccCommentsExist = item.ccCommentsExist ? 1 : 0;
                item.invoicedInd = item.invoicedInd ? 1 : 0;
                item.suppInvoicedInd = item.suppInvoicedInd ? 1 : 0;
                item.suppNdcExcInd = item.suppNdcExcInd ? 1 : 0;
                return item;
              })
            : []
        }
        defaultCol={{ editable: false }}
        columnDefs={columnDefs}
        data-testid="onEditingStopped"
        onCellValueChanged={onEditingStopped}
        enterMovesDown
        suppressCellFocus
        onCellFocused={is508NotReq?onCellFocusedEditable:onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        onCellKeyDown={onCellKeyDown}
        tabToNextCell={is508NotReq?tabToNextEditableCell:null}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        download={download}
        suppressNavigation={suppressNavigation}
        isScrollOn
        fileName="Selected Claims"
        handleViewHistory={handleViewHistory}
        pinnedBottomRowData={
          updatedTable && updatedTable?.length > 0 ? pinnedBottomRowData : []
        }
        fullScreenView={tableFullScreen}
        frameworkComponents={frameworkComponents}
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CLAIM"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};

export default SelectedClaimsTable;
